import {PIXI} from '@colonist/pixi'
import {UIGameKnightController} from '../../../../shared/scripts/ui_game/ui_game_cities_and_knights/UIGameKnightController'
import {UIGamePlayerInformationKnightView} from '../../../../shared/scripts/ui_game/ui_game_cities_and_knights/UIGamePlayerInformationKnightView'
import {UIMGamePlayerInformationKnightView} from './UIMGamePlayerInformationKnightView'
import {UIGameActionButtonMultiView} from '../../../../shared/scripts/ui_game/ui_game_actions/UIGameActionButtonMultiView'
import {UIMGameActionButtonMultiView} from '../ui_game_action/UIMGameActionButtonMultiView'
import {MechanicValidatorKnightPlayer} from '@colonist/game-mechanic-validators'

export class UIMGameKnightController extends UIGameKnightController {
    protected createPlayerInformationKnightView(knightPlayerValidator: MechanicValidatorKnightPlayer): UIGamePlayerInformationKnightView {
        return new UIMGamePlayerInformationKnightView(this.uiGameManager, knightPlayerValidator)
    }

    protected createButtonMultiView(preferredPosition: number, buttonContainer: PIXI.Container): UIGameActionButtonMultiView {
        return new UIMGameActionButtonMultiView(this.uiGameManager, preferredPosition, buttonContainer)
    }
}
